import jwtDecode from "jwt-decode";

export const verifyTokenExpiry = (token, navigate) => {
  try {
    if (!token || token === "") {
      navigate("/login", { replace: true });
      return;
    }
    const jwtTokenDecoded = jwtDecode(token);
    const expirationTime = jwtTokenDecoded.exp * 1000 - 60000;
    if (Date.now() >= expirationTime || token === null || token === undefined) {
      localStorage.removeItem("token");
      navigate("/login", { replace: true });
    }
  } catch (error) {
    localStorage.removeItem("token");
    navigate("/login", { replace: true });
  }
};
